import { CLUSTER_POPUP_CLASSES } from 'www/vue_components/common/PopupMap/constants'

export function getLpuItemTemplate({
  name,
  phone,
  address,
  id,
  lpuHref,
}) {
  const phoneData = phone ? `data-phone="${phone}"` : ''
  const lpuHrefTemplate = lpuHref ? `data-lpu-href="${lpuHref}"` : ''

  return `
        <div
            class="d-flex justify-space-between cursor-pointer ${CLUSTER_POPUP_CLASSES.lpu}"
            ${phoneData}
            data-address="${address}"
            data-id="${id}"
            data-name="${name}"
            ${lpuHrefTemplate}
            data-qa="popup_map_lpu_container"
        >
            <div
                class="py-2 text-body-1 mr-auto"
                data-qa="popup_map_name_lpu_text"
            >
                ${name}
            </div>
            <span class="ui-icon-arrow-right my-auto text-info--text"></span>
        </div>
    `
}
